/**
 * page-ocean-recycled.js
 *
 * The js for ocean Recycled page.
 *
 * @author  Tony Nguyen
 * @email   tony.nguyen@tpf.com.au
 * @company TPF Group
 */

// Countup library
import 'waypoints/lib/jquery.waypoints.js';
import '../components/jquery.countup.js';

// Parallax library
import universalParallax from '../components/universal-parallax.js';

export default class OceanRecycledPage {
    constructor() {
        console.info('OceanRecycledPage.constructor()');

        this.initListeners();
    }

    initListeners() {
        console.info('OceanRecycledPage.initListeners()');

        // number animate
        $('#main .number').countUp({
            time: 5000,
        });

        // Parallax
        new universalParallax().init();

        // ajax find impact by code
        $('#impactForm').submit((e) => {
            e.preventDefault();

            const $code = $('#impactCode');
            const $error = $code.parent().next();
            const $impactData = $('#impactData');
            const $impactModal = $('#trackImpactModal');
            $impactModal.modal('hide');

            if ($code.val().length !== 7) {
                $error.html('Code must be 7 characters').show();
                return false;
            }

            $error.html('');
            $impactData.html('');
            $('#impactLoading').show();

            $.ajax({
                type: 'get',
                url: `/wp-json/electro/v1/impact/get-by-code?code=${$code.val().trim()}`,
                success(response) {
                    if (response.status === 0 && response.data.impact.length > 0) {
                        let html = response.data.impact[0].post_content;

                        if (response.data.impact[0].custom.video !== '') {
                            html += `<div class="video"><video id="impactVideo" style="object-fit: cover; background-size: cover; opacity: 1; width: 100%; height: 100%; display: block;" preload="auto" loop="loop" controls="controls" width="300" height="150">
                          <source src="${response.data.impact[0].custom.video}" type="video/mp4" />
                       </video></div>`;
                        }

                        $impactData.html(html);

                        $impactModal.modal('show');
                    } else {
                        $error.html('Your code is invalid.').show();
                    }
                    $('#impactLoading').hide();
                },
                error(xhr, status) {
                    $('#impactLoading').hide();
                },
            });

            $('#trackImpactModal').on('hidden.bs.modal', (e) => {
                const video = document.getElementById('impactVideo');
                if (video) {
                    video.pause();
                }
            });

            // animate scroll number modal
            $impactModal.scroll(() => {
                $impactModal.find('.number').each(function () {
                    const $this = $(this);
                    const isOnView = isElementVisible($(this));
                    if (isOnView && !$this.hasClass('starting')) {
                        $impactData.find('.number').countUp({
                            time: 5000,
                        });
                        $(this).addClass('starting');
                    } else if (!isOnView && $this.hasClass('starting')) {
                        $(this).removeClass('starting');
                    }
                });
            });

            function isElementVisible($elementToBeChecked) {
                const TopView = $(window).scrollTop();
                const BotView = TopView + $(window).height();
                const TopElement = $elementToBeChecked.offset().top;
                const BotElement = TopElement + $elementToBeChecked.height();
                return BotElement <= BotView && TopElement >= TopView;
            }
        });
    }
}
